import React, {useEffect} from 'react'

interface propType{
    key: string,
    defaultValue: object
}

export const usePersistedStateSessionStorage = (props: propType) => {
    const {key, defaultValue} = props
    const [state, setState] = React.useState(() => {
        try {
            // Get from local storage by key
            const item = window.sessionStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : defaultValue;
          } catch (error) {
            // If error also return initialValue
            console.log(error);
            return defaultValue;
          }
    });


    useEffect(() => {
        // update data saved on every change
      sessionStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);
    
    return {state, setState};
  }